import React, { useState } from "react";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const CompanyCertificate = () => {
    const [show, setShow] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const handleClose = () => setShow(false);
    const handleShow = (image) => {
        setSelectedImage(image);
        setShow(true);
    };

    // Sample gallery images
    const galleryImages = [
        "certificate1.jpeg", // Adjust path if necessary
        "certificate2.jpeg",

    ];

    return (
        <div className="container my-5">
            {/* Main Certificate Section */}
            <div className="card shadow-lg mb-5">
                <div className="card-header bg-primary text-white text-center">
                    <h3>Company Certificate</h3>
                </div>
                <div className="card-body">
                    <div className="text-center mb-4">
                        <img
                            src="logo.png"
                            alt="Company Logo"
                            className="img-fluid rounded"
                        />
                    </div>
                    <h5 className="text-center font-weight-bold">
                        Certificate of Incorporation
                    </h5>
                    <p className="text-center">
                        This is to certify that the company is officially registered under
                        the Government of India and is authorized to operate within its
                        jurisdiction.
                    </p>
                    <hr />
                    <div className="text-center">
                        <h6 className="font-weight-bold">RNI Number:</h6>
                        <p className="text">UPHIN/2022/8338</p>
                    </div>

                </div>
                <div className="card-footer bg-light text-center">
                    <small className="text-muted">
                        For verification or queries, please contact the Registrar of
                        Newspapers for India.
                    </small>
                </div>
            </div>

            {/* Gallery Section */}
            <div className="card shadow-lg">
                <div className="card-header bg-secondary text-white text-center">
                    <h3>Gallery</h3>
                </div>
                <div className="card-body">
                    <div className="row">
                        {galleryImages.map((image, index) => (
                            <div className="col-md-4 mb-3" key={index}>
                                <div className="card">
                                    <img
                                        src={image}
                                        alt={`Certificate ${index + 1}`}
                                        className="card-img-top"
                                        onClick={() => handleShow(image)}
                                        style={{ cursor: "pointer" }}
                                    />
                                    <div className="card-body text-center">
                                        <p className="card-text">Certificate {index + 1}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Modal for full-size image view */}
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Certificate Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedImage && (
                        <img
                            src={selectedImage}
                            alt="Selected Certificate"
                            className="img-fluid"
                        />
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default CompanyCertificate;
